import { motion } from "framer-motion";
import React, { ReactNode } from "react";
import { AuroraBackground } from "@/components/ui/aurora-background";

interface AuroraHeroProps {
  children: ReactNode;
  className?: string;
}

/**
 * Componente Hero com Aurora Background
 * Usa o mesmo padrão do home mas pode ser reutilizado em outras páginas
 */
export function AuroraHero({ children, className = "" }: AuroraHeroProps) {
  return (
    <AuroraBackground className={className}>
      <motion.div
        initial={{ opacity: 0.0, y: 40 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{
          delay: 0.3,
          duration: 0.8,
          ease: "easeInOut",
        }}
        className="relative flex flex-col gap-4 items-center justify-center px-4 sm:px-6 pt-28 sm:pt-32 pb-16 sm:pb-20 z-10 w-full"
      >
        {children}
      </motion.div>
    </AuroraBackground>
  );
}
